import AssistantChat from "@/components/assistant/AssistantChat";

// Opening the assistant grants nothing: every request is checked on the server
// against the staff member's existing DFA permissions.
export default function StaffAssistant() {
  return <AssistantChat testId="staff-assistant"
    subtitle="Your DFA assistant. It works within your existing SMS permissions."
    footnote="The assistant only uses official DFA records you are already permitted to see. Some enquiries are not yet available."
    unavailableText="The DFA Virtual Assistant has not been enabled for your account. Please ask an administrator." />;
}
